import { SET_IS_LOCKED_ROOM, SET_LOCKED_ROOM_LIVE_METADATA } from "../../global/actions/global-actions-types";

const INITIAL_STATE_SET_IS_LOCKED_ROOM = { isLockedRoom: '' }

export function setIsLockedRoomReducer(state = INITIAL_STATE_SET_IS_LOCKED_ROOM, action) {
    switch (action.type) {
        case SET_IS_LOCKED_ROOM:
            return { isLockedRoom: action.payload }
        default:
            return state;
    }
}


const INITIAL_STATE_LOCKED_ROOM_LIVE_METADATA = { results: '' }

export function setLockedRoomMetadataReducer(state = INITIAL_STATE_LOCKED_ROOM_LIVE_METADATA, action) {
    switch (action.type) {
        case SET_LOCKED_ROOM_LIVE_METADATA:
            return { results: action.payload }
        default:
            return state;
    }
}